import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20epic%20banner%2C%20dramatic%20composition%20with%20warm%20red%20and%20gold%20flowing%20light%20streaks%2C%20dynamic%20motion%20blur%20effects%2C%20cinematic%20lighting%2C%20rich%20dark%20and%20warm%20color%20palette%2C%20action%20atmosphere%2C%20digital%20illustration%2C%20professional%20webtoon%20art&width=1600&height=900&seq=hero-banner-01&orientation=landscape"
        alt="韩漫漫画网 - 免费韩国漫画在线观看"
        title="韩漫大全 - 好看的韩国漫画免费在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <p className="text-background-50/80 text-sm md:text-base font-medium tracking-widest mb-4 whitespace-nowrap">
          韩 漫 大 全
        </p>
        <h1 className="text-3xl md:text-6xl font-bold font-heading text-background-50 text-center leading-tight mb-3 whitespace-nowrap">
          探索韩国漫画的无限世界
        </h1>
        <p className="text-lg md:text-2xl font-heading italic text-background-50/90 text-center mb-4 whitespace-nowrap">
          高清画质 · 极速加载 · 完全免费
        </p>
        <p className="text-sm md:text-base text-background-50/70 text-center max-w-xl mb-8 leading-relaxed">
          汇聚海量韩漫大全作品，推荐好看的韩国漫画免费在线观看，是您探索韩漫世界的最佳选择
        </p>
        <Link
          to="/category"
          className="px-8 py-3 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即探索
        </Link>
      </div>
    </section>
  );
}